import { StyleSheet } from 'aphrodite';
import { SPACE } from '../../../../../../web/components-v2/Theme/theme';
import { backgroundAlt, borderColor, brandPrimary, darkGrayFontColor } from '../../../../../../web/styles/colors';
import { shadowSm } from '../../../../../../web/styles/shadows';

export const styleSheet = StyleSheet.create({
	container: {
		marginBottom: SPACE[16],
		position: 'relative',
		zIndex: 10,
		display: 'grid',
		gridTemplateColumns: 'repeat(auto-fill, minmax(min(272px, 100%), 1fr))',
		gap: 8,
	},
	filterGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: '4px',
		minWidth: '150px',
		position: 'relative',
		zIndex: 1,
	},
	label: {
		fontSize: 12,
		fontWeight: 'bold',
	},
	dateRange: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
	},
	dateInput: {
		padding: '4px 12px',
		border: `1px solid ${borderColor}`,
		height: 36,
		width: '100%',
		borderRadius: 6,
		backgroundColor: 'transparent',
		fontSize: '14px',
		minWidth: 0,
		boxSizing: 'border-box',
		boxShadow: shadowSm,
		transition: 'color 150ms ease-in-out, box-shadow 150ms ease-in-out',
		outline: 'none',
		':disabled': {
			pointerEvents: 'none',
			cursor: 'not-allowed',
			opacity: 0.5,
		},
		':placeholder': {
			color: darkGrayFontColor,
		},
		':selection': {
			backgroundColor: brandPrimary,
			color: backgroundAlt,
		},
		':focus-visible': {
			border: `1px solid #A1A1A1`,
		},
	},
	dateSeparator: {
		fontSize: '12px',
		opacity: 0.7,
	},
	filterValue: {
		color: '#FFFFFF',
		fontSize: '14px',
	},
	clearFilterGroup: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	// Styles to ensure select components appear above other content
	selectWrapper: {
		position: 'relative',
		zIndex: 100,
	},
	managerSelect: {
		':has(*) .common-autocomplete-search-icon': {
			width: 12,
			height: 12,
			marginRight: 4,
		},
	},
	managerSelectAutoCompleteInputWrapper: {
		padding: '4px 12px',
		border: `1px solid ${borderColor} !important`,
		height: 36,
		width: '100%',
		display: 'flex',
		borderRadius: 6,
		backgroundColor: 'transparent !important',
		fontSize: '14px',
		minWidth: 0,
		boxSizing: 'border-box',
		boxShadow: shadowSm,
		transition: 'color 150ms ease-in-out, box-shadow 150ms ease-in-out',
		outline: 'none',
		':has(input:disabled)': {
			pointerEvents: 'none',
			cursor: 'not-allowed',
			opacity: 0.5,
		},
		':has(input:placeholder)': {
			color: darkGrayFontColor,
		},
		':has(input:selection) ': {
			backgroundColor: brandPrimary,
			color: backgroundAlt,
		},
		':has(input:focus-visible)': {
			border: `1px solid #A1A1A1 !important`,
		},
	},
	// Global override for select dropdowns within this component
	'@global': {
		'.callFilters .Select__menu': {
			zIndex: '1000 !important',
		},
		'.callFilters .Select__menu-list': {
			zIndex: '1000 !important',
		},
		'.callFilters [class*="menu"]': {
			zIndex: '1000 !important',
		},
		// Target all autocomplete components in call filters
		'.callFilters .common-autocomplete .autocomplete-search-field-input': {
			background: 'rgba(255, 255, 255, 0.1) !important',
			border: '1px solid rgba(255, 255, 255, 0.3) !important',
			borderRadius: '4px !important',
			color: '#FFFFFF !important',
			fontSize: '14px !important',
			width: '180px !important',
			height: '38px !important',
			boxSizing: 'border-box !important',
			padding: '8px 12px !important',
		},
		'.callFilters .common-autocomplete .autocomplete-search-field-input input': {
			color: '#FFFFFF !important',
			fontSize: '14px !important',
			background: 'transparent !important',
			border: 'none !important',
		},
		// Target OutcomeSelect specifically
		'.callFilters .outcome-select': {
			background: 'rgba(255, 255, 255, 0.1) !important',
			border: '1px solid rgba(255, 255, 255, 0.3) !important',
			borderRadius: '4px !important',
			width: '180px !important',
			height: '38px !important',
			padding: '8px 12px !important',
			boxSizing: 'border-box !important',
			fontSize: '14px !important',
		},
		'.callFilters .outcome-select span': {
			color: '#FFFFFF !important',
		},
	},
});
